<template>
  <ul class="login-section is-hidden-mobile">
    <li><router-link v-translate :to="loginRoute" class="dark-gray-link paragraph-s">Login</router-link></li>
    <li><router-link v-translate :to="registerRoute" class="dark-gray-link paragraph-s">Register</router-link></li>
  </ul>
</template>

<script>
export default {
  computed: {
    isCurrentRouteCandidate() {
      return (
        this.$route.name === 'reset-password-candidate-confirmation' ||
        this.$route.name === 'reset-password-candidate' ||
        this.$context.isTop20Talent
      );
    },
    loginRoute() {
      return this.isCurrentRouteCandidate ? {name: 'login-candidate'} : {name: 'login-employer'};
    },
    registerRoute() {
      return this.isCurrentRouteCandidate ? {name: 'register-candidate'} : {name: 'register-employer'};
    }
  }
};
</script>

<style lang="scss" scoped>
.login-section {
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  padding: 25px 10px;
  display: flex;
  justify-content: flex-end;
  li {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
